// DS: i7.8
import React from 'react';
import IconWrap from '../../IconWrap';
const EditorAlignRight = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M19 5a1 1 0 110 2h-9a1 1 0 110-2h9zm1 13a1 1 0 01-1 1h-9a1 1 0 110-2h9a1 1 0 011 1zm0-6a1 1 0 01-1 1H5a1 1 0 110-2h14a1 1 0 011 1z",
        clipRule: "evenodd"
    })));
};
EditorAlignRight.displayName = 'EditorAlignRight';
export default EditorAlignRight;

//# sourceMappingURL=EditorAlignRight.js.map